import { CariOdemePage } from './../../cari-odeme/cari-odeme';
import { CariTahsilatPage } from './../cari-tahsilat/cari-tahsilat';
import { CarieklePage } from './../cariekle/cariekle';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { CarilerPage } from './../cariler/cariler';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { BllOrtak } from '../../../providers/bll/bll-ortak';




/**
 * Generated class for the CariIslemPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-cari-islem',
  templateUrl: 'cari-islem.html',
})
export class CariIslemPage {
 // cari: any = { LogicalRef: -1, Definition_: "", ClCardRef: "", };
  //vWCari: any={};
  vWCari:any={};
gelencari:any={};
  constructor(public navCtrl: NavController,public modalCtrl:ModalController,public viewCtrl:ViewController,public bllOrtak:BllOrtak, public navParams: NavParams) {
    if (navParams.get("vwCari") != null) {
      this.vWCari = navParams.get("vwCari");
      var data = new FormData();
      this.gelencari.LogicalRef=this.vWCari.ID;
      data.append("cari_id", this.gelencari.ID);
      
    }
    
  }

  ionViewDidLoad() {

  }
  kapat() {
    this.viewCtrl.dismiss();
  }
  CariTahsilat() {
    let modal = this.modalCtrl.create(CariTahsilatPage, { vWCari: this.vWCari });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
   
  
  }
   CariOdeme(){
     let modal = this.modalCtrl.create(CariOdemePage,{ vwCari: this.vWCari });
  modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
   }
}


// WEBPACK FOOTER //
// ./src/pages/CariIslemleri/cari-islem/cari-islem.ts